import GetAppLogsRequestModelBase from '../_generated/modelBases/get-app-logs-request-model-base';

export default class GetAppLogsRequestModel extends GetAppLogsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
